export default __webpack_public_path__ + "static/media/image5.e10abd8a.jpg";